import { useEffect } from 'react'
import { View, Text, TouchableOpacity, StyleSheet, Platform, TouchableWithoutFeedback, Animated, ScrollView, Linking } from 'react-native'
import { routeStores } from '../../../themeConstants'
import { Image } from 'expo-image'
import theme from '../../../theme'

export const WebMobileAlert = () => {
    useEffect(() => {
        if (Platform.OS === 'web') {
            // Guardamos los estilos originales
            const originalOverflow = document.body.style.overflow
            const originalPosition = document.body.style.position
            const originalWidth = document.body.style.width

            // Bloqueamos el scroll del body
            document.body.style.overflow = 'hidden'
            document.body.style.position = 'fixed'
            document.body.style.width = '100%'

            // También prevenimos scroll en el documento raíz
            document.documentElement.style.overflow = 'hidden'

            // Evitamos que se mueva con la rueda del mouse o el touch
            const preventScroll = (e) => e.preventDefault()
            window.addEventListener('wheel', preventScroll, { passive: false })
            window.addEventListener('touchmove', preventScroll, { passive: false })

            // Al desmontar, restauramos todo
            return () => {
                document.body.style.overflow = originalOverflow
                document.body.style.position = originalPosition
                document.body.style.width = originalWidth
                document.documentElement.style.overflow = ''
                window.removeEventListener('wheel', preventScroll)
                window.removeEventListener('touchmove', preventScroll)
            }
        }
    }, [])
    const goToStore = (store) => {
        if (store === '') return
        Linking.openURL(store)
    }
    return (
        <View style={WebMobileModalStyles.parent}>
            <Animated.View style={{ ...WebMobileModalStyles.overlay }} />

            <View style={[WebMobileModalStyles.container, { paddingHorizontal: 16 }]}>
                <Image style={{ width: 130, aspectRatio: 1, marginTop: 22 }} source={require('../../../assets/downloadApp.png')} />
                <Text
                    style={{
                        fontSize: 18,
                        fontWeight: 'bold',
                        color: theme.colors.textPrimary,
                        textAlign: 'center',
                        marginBottom: 5,
                        marginTop: 10,
                        paddingHorizontal: 25,
                    }}
                >
                    Usá la App para una mejor experiencia 📱
                </Text>
                <Text
                    style={{
                        maxWidth: '94%',
                        fontSize: 14,
                        fontWeight: '500',
                        color: theme.colors.textPrimary,
                        textAlign: 'center',
                        marginBottom: 18,
                        marginTop: 6,
                    }}
                >
                    La versión web está disponible solo en computadoras. Descargá la App desde tu store y accedé desde tu celular.
                </Text>

                <TouchableOpacity
                    style={[WebMobileModalStyles.buttonContainer, { backgroundColor: theme.colors.colorPrimary }]}
                    onPress={() => goToStore(routeStores.playStoreUrl)}
                >
                    <View style={WebMobileModalStyles.buttonTextContainer}>
                        <Text style={WebMobileModalStyles.buttonText}> Google Play</Text>
                        <Image
                            style={{ height: 15, aspectRatio: 1, tintColor: 'white', marginLeft: 6 }}
                            source={require('../../../assets/playStore.png')}
                        />
                    </View>
                </TouchableOpacity>
                <TouchableOpacity
                    style={[WebMobileModalStyles.buttonContainer, { backgroundColor: theme.colors.colorSecondary, marginBottom: 22 }]}
                    onPress={() => goToStore(routeStores.appStoreUrl)}
                >
                    <View style={WebMobileModalStyles.buttonTextContainer}>
                        <Text style={WebMobileModalStyles.buttonText}>App Store</Text>
                        <Image
                            style={{ height: 15, aspectRatio: 1, tintColor: 'white', marginLeft: 6 }}
                            source={require('../../../assets/appStore.png')}
                        />
                    </View>
                </TouchableOpacity>
            </View>
        </View>
    )
}

const WebMobileModalStyles = StyleSheet.create({
    parent: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width: '100%',
        height: '100dvh',
        zIndex: 9999,
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    overlay: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        zIndex: 0,
    },
    container: {
        maxWidth: 790,
        borderRadius: 30,
        backgroundColor: 'white',
        alignSelf: 'center',
        margin: 0,
        maxHeight: '90vh',
        zIndex: 10000,
        alignItems: 'center',
        marginHorizontal: 24,
    },
    buttonContainer: {
        width: '94%',
        marginBottom: 16,
        height: 40,
        alignContent: 'center',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 10,
    },
    buttonTextContainer: {
        flexDirection: 'row',
        alignItems: 'center', // centra verticalmente texto + imagen
        justifyContent: 'center',
    },
    buttonText: {
        fontSize: 14,
        color: 'white',
    },
})
